// FILE: src/components/LoginModules/hooks/useGoogleLoginHandler.js
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import { useNavigate } from "react-router-dom";
//import api from "../../axios/axiosInstance";

const useGoogleLoginHandler = ({ onLogin, onClose, setError }) => {
    const navigate = useNavigate();
    const handleGoogleSuccess = async (credentialResponse) => {
        const decoded = jwtDecode(credentialResponse.credential);
        
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/auth/social/login/`,
                {
                    provider: "google",
                    id_token: credentialResponse.credential,
                }, {
                withCredentials: true
            }
            );

            const { user } = response.data;

            if (typeof onLogin === "function") {
                await onLogin(user); // Wait for state update
            }

            if (onClose) onClose();
            
            // Use window.location but add a small delay for state update
            setTimeout(() => {
                window.location.href = "/dashboard";
            }, 200);
        } catch (err) {
            setError("Google login failed. Please try again.");
        }
    };

    const handleGoogleError = () => {
        setError("Google login failed.");
    };

    return { handleGoogleSuccess, handleGoogleError };
};

export default useGoogleLoginHandler;
